import React from 'react';
import ImageWrapper from './ImageWrapper';

function DoctorTimeline({ doctorName, doctorImage, doctorDescription, timelineEvents, direction }) {
  return (
    <div className='page__width flex flex-col items-center justify-center text-center mt-20'>
                      <div className="flex items-center gap-1">
            <div className="bg-brand w-16 rounded-full h-[6px]"></div>
            <div className="bg-brand w-8 rounded-full h-[6px]"></div>
            <div className="bg-brand w-2 rounded-full h-[6px]"></div>
          </div>
          <h2 className="text-3xl mb-8 lg:mb-16 font-extrabold text-heading">Кой стои зад всичко?</h2>
    <div className={`flex flex-col ${direction==="reverse"?"lg:flex-row-reverse":"lg:flex-row"} items-start justify-between`}>
      <ImageWrapper src={doctorImage} className="w-full lg:w-2/5 lg:mb-0 mb-8 rounded lg:top-40 lg:sticky" />
      <div className="w-full lg:w-1/2 flex flex-col items-start gap-4">
        <h2 className="text-2xl mx-auto font-bold text-center">
          Професионален Път на <br/>{doctorName}
        </h2>
        <p className="text-gray-600 mb-4">
          {doctorDescription}
        </p>
        <div className="relative border-l border-gray-300 max-w-4xl mx-auto">
          {timelineEvents.map((event, index) => (
            <div key={index} className="mb-8 pl-8">
              <div className="absolute -left-3 w-6 h-6 bg-brand rounded-full border-4 border-white"></div>
              <div className="text-gray-800 font-extrabold text-lg mb-2">
                {event.year}
              </div>
              <p className="text-gray-600">{event.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
  );
}

export default DoctorTimeline;